import { ExternalLinkIcon } from './ExternalLinkIcon';

export function About() {
  return (
    <main className="relative min-h-screen p-4 pb-24">
      <div className="w-full max-w-[560px] text-left text-base md:text-xl font-light leading-relaxed text-black">
        <p>Born 1996 in Harlem.</p>
        <p>
          A multidisciplinary artist living and working in{' '}
          <span className="whitespace-nowrap">Los Angeles.</span>
        </p>
        <br />
        <p>
          <a
            href="https://www.instagram.com/salieflewis/"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center no-underline transition-opacity duration-200 ease-in-out hover:opacity-70"
          >
            Instagram
            <ExternalLinkIcon className="ml-2 translate-y-px" />
          </a>
        </p>
        <p>CV available upon request.</p>
        <br />
        <p>salieflewis@gmail.com</p>
      </div>
      <div
        className="fixed left-4 right-4 text-left text-base font-light text-black md:text-xl"
        style={{ bottom: 'calc(env(safe-area-inset-bottom) + 1rem)' }}
      >
        <a
          href="/"
          className="inline-block w-full max-w-[560px] transition-opacity duration-200 ease-in-out hover:opacity-70"
        >
          Back
        </a>
      </div>
    </main>
  );
}
